import { DeviceType, IS_BELOW_MOBILE, useDeviceType } from 'app/hooks';

/**
 * Returns if the device is mobile and not from the mobile app
 */
export const useIsMobileNotApp = (): boolean => {
    const { device, isBelowProvidedDevices } = useDeviceType(IS_BELOW_MOBILE);
    return isBelowProvidedDevices && device !== DeviceType.MobileApp;
};
